/**
 * The venue detail page's title row (BON-159).
 *
 * Back link, name and stage, extracted from `VenueDetailPage`. The back target
 * is passed in rather than derived here — the page mounts under three different
 * shells and only it knows which list it came from.
 */
import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { VenueStage } from '../../../../api/venues';

import { VenueStagePill } from './VenueStagePill';

export interface VenueDetailHeaderProps {
  name: string;
  stage: VenueStage;
  /** Where "‹ Venues" goes. */
  venuesPath: string;
}

export function VenueDetailHeader({ name, stage, venuesPath }: VenueDetailHeaderProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <Link
        to={venuesPath}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 2,
          fontSize: 12,
          color: 'var(--nb-muted)',
          textDecoration: 'none',
        }}
      >
        <ChevronLeft size={14} />
        Venues
      </Link>
      <h2
        className="nb-display"
        style={{ margin: 0, fontSize: 20, color: 'var(--nb-bark-dark)', letterSpacing: '.01em' }}
      >
        {name}
      </h2>
      <VenueStagePill stage={stage} size="lg" />
    </div>
  );
}
